import GameIds from '../../hub/data/GameIds';

export default {
  // bites earned per round
  bitesPerRound: 3,
  // game id
  gameId: GameIds.SUPER_MATCH,
  // correct selection count to master a round
  correctAnswersToCompleteRound: 4,
  // wrong selection count to fail a round
  wrongAnswersToSimplifyLevel: 4,
  // The number of answer choices in "simplified level" -- one of each combination of (eg) Color + Object type
  numItemsInSimplifiedLevel: 4,
  // max zaps earned available for the game
  zapsAvailable: 10,
  // max level
  availableLevels: 7,
};
